import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import LargeBlock from './large-block'
import SmallBlock from './small-block'

import styles from './features.css'

const Features = ({ staticUrl }) => (
  <div styleName="features">
    <LargeBlock
      centerText
      title="Customer Experience That Converts"
      image={`${staticUrl}${require('images/feature-1.png')}`}
      text="We optimize our checkout funnel for website and app. It is constantly AB tested to get industry
            leading conversion rates on mobile and desktop. In other words, selling tickets has never been easier."
    />

    <LargeBlock
      centerText
      fullHeight
      title="Reach 2 Million Users"
      image={`${staticUrl}${require('images/feature-2.png')}`}
      text="Promote events through the world's best mobile event discovery marketplace. We have accrued over 2 million
            downloads in London alone and host over 20,000 event listings. We have industry-leading engagement and a
            mobile conversion rate of over 15%."
    />

    <div styleName="small-blocks">
      <SmallBlock
        title="Flexible and Intuitive Ticketing"
        text="Our event ticketing system allows you to create events with multiple dates, ticket types and price bands,
              all online from the same flexible backend interface. And, once you set it, you can forget it. It's free
              and easy to started."
      >
        <img
          alt="Flexible and Intuitive Ticketing"
          styleName="image-feature-3"
          src={`${staticUrl}${require('images/feature-3.png')}`}
        />
      </SmallBlock>

      <SmallBlock
        title="Entry Made Easy"
        text="Steamline and speed up admittance at your venues with our ticket scanning app.
              See how many people are attending the event from the comfort of your back office, in real-time."
      >
        <div styleName="image-feature-4">
          <img
            alt="Attendees"
            styleName="image-feature-4-1"
            src={`${staticUrl}${require('images/feature-4-1.png')}`}
          />
          <img
            alt="Access"
            styleName="image-feature-4-2"
            src={`${staticUrl}${require('images/feature-4-2.png')}`}
          />
        </div>
      </SmallBlock>
    </div>
  </div>
)

Features.propTypes = {
  staticUrl: PropTypes.string,
}

export default CSSModules(Features, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/features/features.js
 **/